// Exclusion list: List of templates that should not use this dispatch because backward compatibility is not yet assured
export const gabs = [
  "EMPTY_BANNER",
  "GAB01_REPONSES_POSITIVE_NEGATIVE",
  "GAB01_REPONSES_POSITIVE_NEGATIVE",
  "GAB02_2_REPONSES_POSITIVES",
  "GAB03_MENTION_2REPONSES_CROIX",
  "GAB03B_MENTION_2REPONSES_CROIX",
  "GAB03C_MENTION_2REPONSES_CROIX",
  "GAB04_REPONSES_POSITIVE_NEGATIVE",
  "GAB05_MENTION_2_REPONSES",
  "GAB06_REPONSES_POSITIVES_WEBCALLBACK",
  "GAB07_TLS_2REPONSES",
  "GAB08_REPONSES_POSITIVE_NEGATIVE_NV_ONGLET",
  "GAB09_EMPTY_BANNER_WEBCALLBACK",
  "GAB10_PM_2REPONSES",
  "POPIN_02_ANR",
  "POPIN_03_PAS",
  "POPIN_04_PC",
  "GAB01_ESPACE_IMMO",
  "GAB01_UDC_ANIMATION",
  "GAB01_UDC_ANIMATION_EMERGENCY",
  "GAB10_PM_2REPONSES",
  "GAB11_PM_2REPONSES_AN",
  "GAB11"
];
